
import { computed, defineComponent, toRefs } from 'vue';

import { createStore, useCalculations } from '@/lib/calculationstate';

import { Step, useStepperNavigation } from '@/components/wizard';
import Button, { ButtonType } from '@/components/Button.vue';
import {
  Controls, GraphBar, InsuranceBar, PdfDownloadButton,
} from '@/components/results';
import ExplainPayoutCategory from '@/components/info/explainers/ExplainPayoutCategory.vue';
import { listAllPayoutCategories, useGraphs } from '@/lib/graphs';
import { getPayoutClass, getPayoutLabel, PayoutCategory } from '@/lib/payout';
import { TestimonialPopupList } from '@/components/testimonial';

function generatePayoutButton(category: PayoutCategory): object {
  return {
    id: category,
    name: getPayoutLabel(category),
    color: getPayoutClass(category),
  };
}

export default defineComponent({
  name: 'Results',
  props: {
    step: Number,
  },
  components: {
    InsuranceBar,
    Step,
    Button,
    Controls,
    GraphBar,
    ExplainPayoutCategory,
    PdfDownloadButton,
    TestimonialPopupList,
  },
  data() {
    return {
      ButtonType,
      PayoutCategory,
      explainType: null as null | PayoutCategory,
    };
  },
  setup(props) {
    const { step } = toRefs(props);
    const { prevStep, setStep, isVisible } = useStepperNavigation(step);
    const { state, disabilityPercent, grossMonthlySalary } = useCalculations();

    const resetCalculator = () => {
      // Fresh store we have never touched to get default values from
      const newState = createStore();
      Object.assign(state, newState);
      setStep(1);
    };

    const graphs = useGraphs();
    const activePayoutTypes = computed(() => listAllPayoutCategories(graphs).map(generatePayoutButton));

    return {
      resetCalculator,
      disabilityPercent,
      state,
      isVisible,
      prevStep,
      globalMax: grossMonthlySalary,
      graphs,
      activePayoutTypes,
    };
  },
});
